import atul from "../../assets/images/about-us/atul.jpeg";
import abhinav from "../../assets/images/about-us/abhinav.jpg";
import ajay from "../../assets/images/about-us/ajay.jpeg";
import aakash from "../../assets/images/about-us/aakash.jpeg";
import mission from "../../assets/images/about-us/vision.png";
import vision from "../../assets/images/about-us/mission.png";

// Example SVG icons (replace with your own or use react-icons for more options)
const MissionIcon = () => (
  <svg width="36" height="36" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#66bb6a"/><path d="M8 12l2 2 4-4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
);
const VisionIcon = () => (
  <svg width="36" height="36" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#29b6f6"/><path d="M12 8v4l3 3" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
);
const ProblemIcon = () => (
  <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><rect width="24" height="24" rx="12" fill="#ffd600"/><path d="M12 8v4" stroke="#222" strokeWidth="2" strokeLinecap="round"/><circle cx="12" cy="16" r="1" fill="#222"/></svg>
);
const SolutionIcon = () => (
  <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><rect width="24" height="24" rx="12" fill="#2e7d32"/><path d="M8 12l2 2 4-4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
);

const dividerStyle = {
  borderBottom: '1px solid #e0e0e0',
  margin: '0 auto',
  maxWidth: '1200px',
};

export const AboutUs = () => {
  const teamDetails = [
    {
      image: abhinav,
      name: "Abhinav Gargvansi",
      title: "Co-Founder",
      linkedinurl: "https://www.linkedin.com/in/abhinav-gargvansi-81935a17a/",
    },
    {
      image: atul,
      name: "Atul Tiwari",
      title: "Co-Founder",
      linkedinurl: "https://www.linkedin.com/in/thisisaeytee",
    },
    {
      image: aakash,
      name: "Aakash Pandey",
      title: "Co-Founder",
      linkedinurl: "https://www.linkedin.com/in/aakash-pandey-b29203143",
    },
    {
      image: ajay,
      name: "Ajay Jangid",
      title: "Backend Lead",
      linkedinurl: "https://www.linkedin.com/in/ajay-jangid-70620016a",
    },
  ];

  return (
    <div className="about-modern" style={{background: '#f8f5f0'}}>
      {/* Hero Section */}
      <section className="py-20 px-4 text-center rounded-b-3xl shadow-lg relative overflow-hidden" style={{background: 'transparent'}}>
        <h1 className="text-5xl md:text-6xl font-extrabold mb-4" style={{color: '#205c20'}}>Empowering Indian Agriculture, One Innovation at a Time</h1>
        <p className="text-xl md:text-2xl max-w-2xl mx-auto font-medium mb-8" style={{color: '#222'}}>
          We’re on a mission to transform farming in India—connecting growers, buyers, and technology for a sustainable, prosperous future.
        </p>
      </section>
      <div style={dividerStyle}></div>

      {/* Mission & Vision */}
      <section className="py-20 px-4" style={{background: 'transparent'}}>
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center">
          {/* Mission Card */}
          <div className="card-modern flex flex-col md:flex-row items-center gap-8 bg-white">
            <div className="flex flex-col items-center md:items-start w-full">
              <h2 className="text-3xl font-bold mb-2 mt-4 flex items-center gap-3" style={{color: '#205c20'}}>
                <MissionIcon />
                <span>Our Mission</span>
              </h2>
              <p className="text-base" style={{color: '#222'}}>
                To revolutionize Indian agriculture by empowering farmers with technology, transparent markets, and a supportive community—enabling them to thrive, not just survive.
              </p>
            </div>
            <img src={mission} alt="Mission" className="w-40 h-40 object-contain rounded-2xl bg-section-bg p-2 shadow" />
          </div>
          {/* Vision Card */}
          <div className="card-modern flex flex-col md:flex-row-reverse items-center gap-8 bg-white">
            <div className="flex flex-col items-center md:items-start w-full">
              <h2 className="text-3xl font-bold mb-2 mt-4 flex items-center gap-3" style={{color: '#205c20'}}>
                <VisionIcon />
                <span>Our Vision</span>
              </h2>
              <p className="text-base" style={{color: '#222'}}>
                A future where every Indian farmer is connected, informed, and prosperous. We envision a digital ecosystem where innovation, sustainability, and fair trade drive growth for all.
              </p>
            </div>
            <img src={vision} alt="Vision" className="w-40 h-40 object-contain rounded-2xl bg-section-bg p-2 shadow" />
          </div>
        </div>
      </section>
      <div style={dividerStyle}></div>

      {/* Problem & Solution */}
      <section className="py-20 px-4" style={{background: 'transparent'}}>
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-start">
          {/* Problem Card */}
          <div className="card-modern border-l-4 border-yellow-600 flex flex-col items-start bg-white">
            <h2 className="text-2xl font-bold mb-4 mt-2 flex items-center gap-3" style={{color: '#b28900'}}>
              <ProblemIcon />
              <span>The Challenge</span>
            </h2>
            <p className="text-base" style={{color: '#222'}}>
              Indian farmers face outdated systems, unfair pricing, and limited access to markets and technology. Middlemen and inefficiencies keep profits low and opportunities out of reach.
            </p>
          </div>
          {/* Solution Card */}
          <div className="card-modern border-l-4 border-primary-green flex flex-col items-start bg-white">
            <h2 className="text-2xl font-bold mb-4 mt-2 flex items-center gap-3" style={{color: '#205c20'}}>
              <SolutionIcon />
              <span>Our Solution</span>
            </h2>
            <p className="text-base" style={{color: '#222'}}>
              Halyavara bridges the gap—connecting farmers directly with buyers, providing real-time insights, and fostering a transparent, tech-driven marketplace. We’re building trust, boosting incomes, and cultivating a new era of agricultural prosperity.
            </p>
          </div>
        </div>
      </section>
      <div style={dividerStyle}></div>

      {/* Team Section */}
      <section className="py-20 px-4 rounded-t-3xl relative" style={{background: 'transparent'}}>
        <div className="max-w-6xl mx-auto text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-extrabold mb-4" style={{color: '#205c20'}}>Meet the Changemakers</h2>
          <p className="text-lg max-w-2xl mx-auto mb-8" style={{color: '#222'}}>
            Our passionate team is dedicated to driving innovation and impact in Indian agriculture.
          </p>
          {/* Values/Quote Block */}
          <blockquote className="italic text-base font-semibold max-w-xl mx-auto mb-8" style={{color: '#4a6fa5'}}>“Together, we’re sowing the seeds of a brighter, more sustainable future for Indian farmers.”</blockquote>
        </div>
        <div className="w-full flex flex-nowrap gap-10 about-team-row" style={{minHeight: 'unset', maxWidth: '1200px', margin: '0 auto'}}>
          {teamDetails?.map((element) => (
            <div className="card-modern flex flex-col items-center text-center p-8 hover:shadow-2xl hover:-translate-y-2 transition-all bg-white about-team-card" style={{minWidth: '260px', maxWidth: '300px'}}>
              <img src={element?.image} alt={element?.name} className="w-28 h-28 object-cover rounded-full border-4 border-accent-green shadow mb-4" />
              <p className="name font-bold text-lg mb-1" style={{color: '#205c20'}}>{element?.name}</p>
              <p className="title font-semibold text-sm mb-2" style={{color: '#4a6fa5'}}>{element?.title}</p>
              <div className="flex gap-4 justify-center pt-2">
                <a href={element?.linkedinurl} target="_blank" rel="noopener noreferrer" className="hover:text-sky-blue transition-colors">
                  <i className="fa fa-linkedin-square text-2xl"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
      <div style={dividerStyle}></div>

      {/* CTA Section */}
      <section className="py-16 px-4 text-center" style={{background: 'transparent'}}>
        <h2 className="text-3xl md:text-4xl font-extrabold mb-4" style={{color: '#205c20'}}>Join the AgriTech Revolution</h2>
        <p className="text-base mb-8 max-w-2xl mx-auto" style={{color: '#222'}}>Be part of our journey to empower farmers and transform Indian agriculture. Connect with us today!</p>
        <a href="/contact-us" className="btn-modern">Contact Us</a>
      </section>
    </div>
  );
};
